import React, { useState } from 'react'
import { Platform, Pressable, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'

import { Color, Radius, Spacing } from '../../style'
import { Icon } from '../icon'
import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.greyBlue,
    borderRadius: Radius.S,
    height: 20,
    paddingHorizontal: Spacing.XS,
    alignItems: 'center',
    flexDirection: 'row',
  },
  title: {
    color: Color.simplyWhite,
  },
  close: {
    width: 14,
    height: 14,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: Color.transparent,
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeHovered: {
    borderColor: Color.simplyWhite,
  },
  closePressed: {
    backgroundColor: Color.lightGreyBlue,
  },
  outline: {
    marginLeft: Spacing.XXS,
    marginRight: -Spacing.XXS,
    width: 16,
    height: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Color.transparent,
  },
  outlineActive: {
    borderColor: Color.darkGreyBlue,
  },
})

export interface Props extends ViewProps {
  title?: string
  closeable?: boolean
  onClose?: () => void
  testOnly_pressed?: boolean
}
const Chip = (props: Props) => {
  const { title, closeable, onClose, testOnly_pressed, style, ...otherProps } = props

  const [active, setActive] = useState(false)

  const updateActive = (value: boolean) => () => {
    setActive(value)
  }

  const renderClose = (state: { pressed: boolean; hovered?: boolean }) => {
    const { pressed, hovered } = state
    const closeStyle = [styles.close, hovered && styles.closeHovered, pressed && styles.closePressed]

    const outlineStyle = [styles.outline, active && styles.outlineActive]
    return (
      <View style={outlineStyle}>
        <View style={closeStyle}>
          <Icon name="close" color={Color.simplyWhite} size={8} />
        </View>
      </View>
    )
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text level={7} style={styles.title}>
        {title}
      </Text>
      {closeable && (
        <Pressable
          style={Platform.select({
            // @ts-expect-error outline style none is not defined
            web: {
              outlineStyle: 'none',
            } as ViewStyle,
          })}
          onFocus={updateActive(true)}
          onBlur={updateActive(false)}
          onPress={onClose}
          hitSlop={10}
          testID="Chip.Close"
          testOnly_pressed={testOnly_pressed}
        >
          {renderClose}
        </Pressable>
      )}
    </View>
  )
}

export default Chip
